import React from "react";
import { GroupableVehicleReportGrid } from "./groupableVehicleReportGrid";
import {
    useVehicleReportData,
    VehicleReportData,
    VehicleReportOptionsMapping,
} from "../../../hooks/reporting/useVehicleReportData";
import { MainLayout } from "../../layout/mainLayout";
import { LoadingIndicator } from "../../framework/loadingIndicatorNew";
import { VehicleEventType } from "../../../models/vehicle/vehicleEventInfo";
import { VehicleReportFilters } from "../VehicleReportFilters";

const dataInitialized = (data: VehicleReportData) =>
    !!data.vehicles &&
    !!data.customers &&
    !!data.employees &&
    !!data.costCenters &&
    !!data.eventData &&
    !!data.eventData[VehicleEventType.Distance] &&
    !!data.eventData[VehicleEventType.TotalFuel];

export const GroupableVehiclesMain = () => {
    const data = useVehicleReportData(Object.keys(VehicleReportOptionsMapping), true);
    const initialized = dataInitialized(data);

    return (
        <MainLayout
            noContainer
            className="fluid"
            topComponent={
                <VehicleReportFilters
                    vehicles={data.presentVehicles}
                    costCenters={data.presentCostCenters}
                    employees={data.employees}
                    customers={data.presentCustomers}
                    hideEmployeeGroup
                />
            }
        >
            <>
                <LoadingIndicator loading={data.loading || !initialized} />
                {initialized && <GroupableVehicleReportGrid { ...data }/>}
            </>
        </MainLayout>
    );
};
